module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "paraspaceabovebm"
  }, [_c('a', {
    attrs: {
      "id": "ch07"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Evening.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There is a ritual I have to perform every evening. Almost without exception, I bring work home with me. When it’s finished, I go for a swim in the sea. When it’s summer I try to take the opportunity to swim a little. Then I prepare dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dinner for one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s never elaborate or nutritious: spaghetti with canned tomato sauce, frozen pancakes, Frödinge brand quiche, grilled chicken from the ICA supermarket in Gustavsberg. I don’t even own a cookbook. I drink wine with dinner, carefully clean up after my meal, and then go outside and walk the short stretch between the rosebushes to the bathroom in the shed; I don’t want to risk needing to go outside after the onset of darkness. I call for Ziggy. Sometimes that works. Certain nights he wants to go his own way instead of warming my bed. When I’ve returned to the house, I go through all the rooms and turn on the lights. All the lights: ceiling lamps, bed lamp, desk lamp, even the stove light in the kitchen. I check that the big flashlight is strategically located next to my nightstand. Power outages are not unusual where I live. Then I look out into the darkness through the big windows, which at this time of evening are like empty, black holes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I fall asleep, deeply and dreamlessly, with the help of a little more wine.")]), _vm._v(" "), _c('p', {
    staticClass: "centera"
  }, [_vm._v("•  •  •")])]), _c('p', {
    staticClass: "paraspaceabovebm"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("One of my earliest memories from childhood is when my sister locked me in the closet in her room because I had smeared Nutella in the hair of her Cindy doll. I hadn’t planned to transform the doll’s flowing locks into a poop-brown cake of oily, rancid Nutella. The idea was to make ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Cindy better looking. My mom and my sisters all used face masks and hair packs when they wanted to look really good.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I clearly remember how I begged and pleaded for her to let me out as she roughly and mercilessly shoved me deeper into her closet. “You brat! I’ll kill you if you touch my Cindy again!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was dark and stuffy in the closet, the heavy air felt like it was pressing against my face and my thin limbs, forcing me farther and farther back against my will. I remember a faint odor of wool and dust and something else, like rubber.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Haltingly, I made my way in the darkness with my hands stretched out in front of me. Clothes that had been stored away for the summer brushed against my cheeks and the steel edges of a pair of old skis struck me on the shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My heart was beating faster and faster, and a strange pressure was growing in my chest. My first feeling was surprise rather than fear; it was as if my body became afraid before my intellect understood what was happening, as if I could clearly feel and register all the physiological expressions of fear before I actually "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("realized")]), _vm._v(" I was afraid. I heard the hangers screeching against the rod above and instinctively starting waving my arms. Down jackets, cardigans, and old ski clothes tumbled down with dull thuds around me on the floor, and to my own surprise I heard a peculiar shrill sound emerge from my throat. It sounded just like the pigs we had seen when my class went on a field trip to the farm in Flen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aaauuaa,” I screamed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I then fainted, among the woolen mittens, tracksuits, and neat bundles of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("My Life’s Story")]), _vm._v(" magazine.")]), _vm._v(" "), _c('p', {
    staticClass: "imagecm1"
  }, [_c('img', {
    attrs: {
      "alt": "logo",
      "height": "45",
      "src": "images/common.jpg",
      "width": "60"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c11a6bec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch07.vue
// module id = 99
// module chunks = 0